import {useEffect} from 'react';
import AnalyticsService from '@/services/analytics/AnalyticsService';

function ExternalRedirect({
  url,
  screenName,
  source,
  preserveQueryParams = false,
}: {
  url: string;
  screenName?: string;
  source?: string;
  preserveQueryParams?: boolean;
}) {
  useEffect(() => {
    if (screenName && source) {
      AnalyticsService.screenPresented(screenName, source);
    }

    let destination = url;
    if (preserveQueryParams) {
      const dest = new URL(url);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach((value, key) => {
        if (key.startsWith('utm_')) {
          dest.searchParams.set(key, value);
        }
      });
      destination = dest.toString();
    }

    window.location.replace(destination);
  }, [screenName, source, url, preserveQueryParams]);

  return null;
}

export default ExternalRedirect;
